import React, { useState } from "react";
import { Swiper } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { Row, Col } from "antd";
const CustomSlider = ({
  breakpoints,
  autoplay,
  pagination,
  children,
  slides,
  loop,
  spaceBetween,
  footNavigation,
  data,
  productImagesSize,
  referrer,
  childLength,
}) => {
  const swiperRef = React.useRef(null);

  const [activeSlide, setActiveSlide] = useState(0);
  const handleSetActiveSlide = (index) => {
    if (swiperRef.current) {
      swiperRef.current.swiper.slideTo(index);
      setActiveSlide(index);
    }
  };
  return (
    <Row>
      <Col>
        <Swiper
          ref={swiperRef}
          modules={[Autoplay, Pagination]}
          slidesPerView={slides}
          spaceBetween={spaceBetween}
          breakpoints={breakpoints}
          autoplay={autoplay}
          loop={loop}
          pagination={pagination}
          onSlideChange={(Swiper) => setActiveSlide(Swiper.realIndex)}
          className="mySwiper"
        >
          {children}
        </Swiper>
        {footNavigation && !data && referrer !== "cards" && (
          <footer className="text-center">
            {children.map((item, index) => (
              <span
                key={index}
                onClick={() => handleSetActiveSlide(index)}
                className={activeSlide === index ? "dot_active" : "dot"}
              />
            ))}
          </footer>
        )}
        {footNavigation && !data && referrer === "cards" && (
          <footer className="text-center">
            {Array.from({ length: childLength || 0 }).map(
              (_, index) =>
                childLength > 1 && (
                  <span
                    key={index}
                    onClick={() => handleSetActiveSlide(index)}
                    className={
                      activeSlide === index
                        ? "card-slider-active"
                        : "card-slider-dot"
                    }
                  />
                )
            )}
          </footer>
        )}

        {footNavigation && data && productImagesSize > 1 && (
          <footer className="text-center pt-1">
            {data.map((item, index) => (
              <span
                key={index}
                onClick={() => handleSetActiveSlide(index)}
                className={
                  item?.type?.toLowerCase()?.includes("image")
                    ? activeSlide === index
                      ? "dot_active"
                      : "dot"
                    : item?.type?.toLowerCase()?.includes("video")
                    ? activeSlide === index
                      ? "video_pagination_active"
                      : "video_pagination"
                    : ""
                }
              />
            ))}
          </footer>
        )}
      </Col>
    </Row>
  );
};

export default CustomSlider;
